/**
 * Class appContext
 *
 * @author Jeremie Nogues
 * @year 2024
 * @filename appContext.js
 * @location /js/my
 */

export default class appContext {
	constructor() {
		this.dependencies = {};
	}

	register(name, instance) {
		this.dependencies[name] = instance;
	}

	get(name) {
		return this.dependencies[name];
	}
}